import { render, staticRenderFns } from "./ChannelPartnerHeading.vue?vue&type=template&id=56e9d6e1&"
import script from "./ChannelPartnerHeading.vue?vue&type=script&lang=js&"
export * from "./ChannelPartnerHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports